<template>
  <div>
    <div class="left_item">
      <div class="titleOne titleTwo">目的地：</div>
      <div class="contentTwo">
        <span>{{item.destination}}</span>
      </div>
    </div>
    <div class="left_item">
      <div class="titleOne titleTwo">预估出行日期：</div>
      <div class="contentTwo">
        <span>{{item.travelDate}}</span>
      </div>
    </div>
    <div class="left_item">
      <div class="titleOne titleTwo">预估出行人数：</div>
      <div class="contentTwo">
        <span>{{item.travelNumber}}</span>
        <span class="Icon">{{item.travelType==1?'私家团':'企业团'}}</span>
      </div>
    </div>
    <div class="left_item">
      <div class="titleOne titleTwo">预估所需项目：</div>
      <div class="contentTwo">
        <span>{{item.containProject}}&nbsp;</span>
      </div>
    </div>
    <div class="left_item">
      <div class="titleOne titleTwo">期待及主题：</div>
      <div class="contentTwo">
        <span v-for="(item1,index1) in item.theme" :key="index1">{{item1}}&nbsp;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    item:{
      type:Object,
      default:()=>{return{}}
    }
  }
}
</script>

<style lang="scss" scoped>
.left_item{
  display:flex;
  margin-bottom:0.1rem;
  align-items: center;
  .titleOne{
    width: 1rem !important;
  }
  .titleTwo{
    color:#ED8666;
    width: 0.5rem;
  }
  .contentTwo{
    color:#101010;
    width:6rem;
    .Icon{
      margin-left: 0.1rem;
      display: inline-block;
      padding: 0.02rem 0.02rem;
      text-align: center;
      background: #F7EAED;
      border-radius: 5px;
    }
  }
}
</style>